import { Badge } from "@mantine/core";
import { type Fixture } from "@prisma/client";

type MatchResult = "W" | "L" | "D" | null;

type FixtureFields = Pick<
  Fixture,
  | "teamHomeId"
  | "teamAwayId"
  | "score_home"
  | "score_away"
  | "status_short"
  | "score_penalty_home"
  | "score_penalty_away"
>;

function getMatchResult(
  currentTeamId: number,
  fixture: FixtureFields,
): MatchResult {
  const homeTeamId = fixture.teamHomeId;
  const awayTeamId = fixture.teamAwayId;
  const homeScore = fixture.score_home;
  const awayScore = fixture.score_away;

  if (homeScore === null || awayScore === null) {
    return null;
  }

  if (currentTeamId === homeTeamId) {
    // Current team is the home team
    if (homeScore > awayScore) {
      return "W"; // Home team wins
    } else if (homeScore < awayScore) {
      return "L"; // Home team loses
    } else {
      if (fixture.status_short === "PEN") {
        if (
          fixture.score_penalty_home === null ||
          fixture.score_penalty_away === null
        ) {
          return null;
        }
        return fixture.score_penalty_home > fixture.score_penalty_away
          ? "W"
          : "L";
      }
      return "D"; // Draw
    }
  } else if (currentTeamId === awayTeamId) {
    // Current team is the away team
    if (awayScore > homeScore) {
      return "W"; // Away team wins
    } else if (awayScore < homeScore) {
      return "L"; // Away team loses
    } else {
      if (fixture.status_short === "PEN") {
        if (
          fixture.score_penalty_home === null ||
          fixture.score_penalty_away === null
        ) {
          return null;
        }
        return fixture.score_penalty_away > fixture.score_penalty_home
          ? "W"
          : "L";
      }
      return "D"; // Draw
    }
  } else {
    return null;
    // Current team is neither the home nor the away team
    // throw new Error("Invalid team ID");
  }
}

type Props = {
  fixture: FixtureFields;
  teamId: number;
};

export function WinLossBadge({ fixture, teamId }: Props) {
  const matchResult = getMatchResult(teamId, fixture);
  return (
    <Badge
      color={
        matchResult === "W" ? "green" : matchResult === "L" ? "red" : "gray"
      }
      variant="light"
      radius="xs"
      style={{ fontFamily: "monospace" }}
      miw={32}
    >
      {matchResult}
    </Badge>
  );
}
